import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from '@oasisprotocol/ui-library/src/components/typography'
import { Button } from '@oasisprotocol/ui-library/src/components/ui/button'
import telegram from './images/telegram.svg'
import twitter from './images/twitter.svg'
import discord from './images/discord.svg'
import { socialMedia } from '../../utils/externalLinks'

type SocialButtonProps = {
  label: string
  href: string
  imgSrc: string
}

const SocialButton: FC<SocialButtonProps> = ({ label, href, imgSrc }) => {
  return (
    <Button type="button" variant="outline" size="lg" className="min-w-[110px]" asChild>
      <a href={href} rel="noopener noreferrer" target="_blank">
        <img src={imgSrc} alt="" className="h-4 w-4" />
        {label}
      </a>
    </Button>
  )
}

export const Social: FC = () => {
  const { t } = useTranslation()
  const links = [
    socialMedia.twitter && {
      key: 'twitter',
      label: t('social.twitter'),
      href: socialMedia.twitter,
      imgSrc: twitter,
    },
    socialMedia.telegram && {
      key: 'telegram',
      label: t('social.telegram'),
      href: socialMedia.telegram,
      imgSrc: telegram,
    },
    socialMedia.discord && {
      key: 'discord',
      label: t('social.discord'),
      href: socialMedia.discord,
      imgSrc: discord,
    },
  ].filter(Boolean) as { key: string; label: string; href: string; imgSrc: string }[]

  return (
    <div className="w-full h-full p-6 md:p-8 relative bg-white border border-[#E3E8EF] rounded-xl flex flex-col gap-5 justify-center">
      <div className="flex flex-col items-start gap-2">
        <Typography className="text-xl md:text-2xl font-bold leading-6 md:leading-8 text-[#0F172A]">
          {t('social.header')}
        </Typography>
        <Typography className="text-[#64748B] leading-5" variant="small">
          {t('social.community')}
        </Typography>
      </div>
      {links.length > 0 && (
        <div className="flex flex-wrap items-center gap-3">
          {links.map(link => (
            <SocialButton key={link.key} label={link.label} href={link.href} imgSrc={link.imgSrc} />
          ))}
        </div>
      )}
    </div>
  )
}
